import { render, staticRenderFns } from "./DepList.vue?vue&type=template&id=008e4fd5&"
import script from "./DepList.vue?vue&type=script&lang=js&"
export * from "./DepList.vue?vue&type=script&lang=js&"
import style0 from "./DepList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports